module.exports = __webpack_public_path__ + "img/closeIcon2.1c0d2031.png";